import { create } from "zustand";

// Stato effimero dell'editor (strumenti, selezione, disegno, undo/redo).
export const useEditor = create((set, get) => ({
  tool: "select", // select | draw-roof | draw-obstacle | delete-module | pan
  draft: [], // vertici in corso (metri)
  hover: null, // punto mouse (metri) per anteprima
  selId: null, // id tetto/ostacolo selezionato
  activeRoof: null, // id tetto attivo
  showZones: false,
  selField: null, // { rid, i } campo moduli selezionato
  setSelField: (selField) => set({ selField }),
  showGroupDims: true,
  setShowGroupDims: (showGroupDims) => set({ showGroupDims }),
  showDims: true,
  showBg: true,
  showShadows: true,
  snap: true,
  editEdge: null, // { rid, i } lato in modifica numerica
  struct: null, // ultimo calcolo strutturale (binari/ganci/zavorra)
  setStruct: (struct) => set({ struct }),
  georef: null, // { px: [[x,y],[x,y]], ll: [] } punti di georeferenziazione dello sfondo
  setGeoref: (georef) => set({ georef }),
  bgError: false,
  setBgError: (bgError) => set({ bgError }),
  busy: false,
  setBusy: (busy) => set({ busy }),

  setEditEdge: (editEdge) => set({ editEdge }),
  setTool: (tool) => set({ tool, draft: [] }),
  setHover: (hover) => set({ hover }),
  addVertex: (p) => set((s) => ({ draft: [...s.draft, p] })),
  popVertex: () => set((s) => ({ draft: s.draft.slice(0, -1) })),
  clearDraft: () => set({ draft: [], hover: null }),
  select: (selId) => set({ selId }),
  setActiveRoof: (activeRoof) => set({ activeRoof }),
  toggle: (k) => set((s) => ({ [k]: !s[k] })),

  // history: stack di snapshot { roofs, modules }
  past: [], future: [],
  pushHistory: (snap) => set((s) => ({ past: [...s.past.slice(-49), snap], future: [] })),
  undo: (cur) => {
    const { past } = get();
    if (!past.length) return null;
    const prev = past[past.length - 1];
    set({ past: past.slice(0, -1), future: [cur, ...get().future].slice(0, 50) });
    return prev;
  },
  redo: (cur) => {
    const { future } = get();
    if (!future.length) return null;
    const next = future[0];
    set({ future: future.slice(1), past: [...get().past, cur].slice(-50) });
    return next;
  },
  canUndo: () => get().past.length > 0,
  canRedo: () => get().future.length > 0,
  resetHistory: () => set({ past: [], future: [] }),
  pid: null,
  resetFor: (pid) => set({ pid, tool: "select", draft: [], hover: null, selId: null, activeRoof: null, editEdge: null, struct: null, past: [], future: [] }),
}));
